import React from "react";
import { useMemo } from "react";
import { Container } from "./TableWidgetsListMoleculeStyle";
import TableWidget from "../../atoms/TableWidget/TableWidgetAtom";
import { ReactComponent as NewIcon } from "../../assets/new.svg";
import { ReactComponent as PharmaciesIcon } from "../../assets/pharmacies.svg";
import { Bell, ArrowUpFromLine } from "lucide-react";
import { useHistory } from "react-router-dom";
import NotificationBuzzer from "../../atoms/NotificationBuzzer/NotificationBuzzer";
import { useAuthState } from "../../context/AuthContext";
import { UserRole } from "../../utilities/Enums";
import { isUserRoleEqual } from "../../utilities/checkUserRole";
import { ALL_PHARMACIES_RETURNS_PATH } from "../../utilities/returnRequestsListQuery";
import { ADMIN_HOME_PATH } from "../../utilities/adminHomeListQuery";
import { ADMIN_NOTIFICATIONS_PATH } from "../../utilities/adminNotificationsListQuery";
export interface TableWidgetsListMoleculeProps {}

const TableWidgetsList: React.FC<TableWidgetsListMoleculeProps> = () => {
  const history = useHistory();
  const { user } = useAuthState();

  const renderList = useMemo(() => {
    const widgets = [
      {
        backgroundColor: "#B32326",
        label: "Home",
        number: "120",
        icon: <PharmaciesIcon />,
        onClick: () => {
          history.push(ADMIN_HOME_PATH);
        },
      },
      {
        backgroundColor: "#636ED8",
        label: "Return Requests",
        number: "120",
        icon: <NewIcon />,
        onClick: () => {
          history.push(ALL_PHARMACIES_RETURNS_PATH);
        },
      },
      {
        backgroundColor: "#323A87",
        label: "Notifications",
        number: "120",
        icon: <Bell size={50} color="white" />,
        onClick: () => {
          history.push(ADMIN_NOTIFICATIONS_PATH);
        },
        buzzer: <NotificationBuzzer />,
      },
      {
        backgroundColor: "#808080",
        label: "Upload Actual Prices" ,
        number: "120",
        icon: <ArrowUpFromLine size={50} color="white" />,
        onClick: () => {
          history.push("/admin/actual-prices/upload");
        },
      },
    ];

    const filteredWidgets = widgets.filter((item) => {
      if (isUserRoleEqual(user?.role, UserRole.FieldProcessor)) {
        return (
          item.label !== "Upload Drugs Info" && item.label !== "Notifications"
        );
      }
      return true;
    });

    return filteredWidgets.map((item, i) => (
      <TableWidget
        backgroundColor={item.backgroundColor}
        label={item.label}
        icon={item.icon}
        number={item.number}
        key={i}
        onClick={item.onClick}
        buzzer={item.buzzer}
      />
    ));
  }, [history, user?.role]);

  return <Container>{renderList}</Container>;
};
export default TableWidgetsList;
